import * as React from 'react';
import { Button } from '@cian/ui-kit';
import { Link } from '../../../Link';
import * as style from './ManyReviewsTeaser.css';
import { useQuestionsFeature } from '../../../../hooks/useQuestionsFeature';
import { QuestionOnboardingFeature } from '../../../QuestionFeatureOnboarding';
import {
  EOnboardingClickTarget,
  trackOnboardingClick,
  trackShowOnboarding,
} from '../../../QuestionFeatureOnboarding/tracking';

export interface IReviewsFooterProps {
  fullUrl: string;
  reviewsCountText: string;
  showReviewsLinkClick: () => void;
}

export const ReviewsFooter: React.FC<IReviewsFooterProps> = ({ fullUrl, reviewsCountText, showReviewsLinkClick }) => {
  const { isQuestionsFeatureEnabled, isOnboardingShown, setIsOnboardingShown, onOnboardingShown } =
    useQuestionsFeature();

  const onOnboardingClose = () => setIsOnboardingShown(false);

  const handleOnboardingShown = () => {
    if (isOnboardingShown) {
      onOnboardingShown();
      trackShowOnboarding();
    }
  };

  const onReviewLinkClick = React.useCallback(() => {
    if (isOnboardingShown) {
      trackOnboardingClick(EOnboardingClickTarget.TO_REVIEW);
    }
  }, [isOnboardingShown]);

  const onQuestionLinkClick = React.useCallback(() => {
    if (isOnboardingShown) {
      trackOnboardingClick(EOnboardingClickTarget.TO_QUESTION);
    }
  }, [isOnboardingShown]);

  return (
    <div className={style['footer']}>
      <Link url={`${fullUrl}otzyvy/#new-review`} target="blank" onClick={onReviewLinkClick}>
        <Button size="XS" theme="fill_primary">
          Написать отзыв
        </Button>
      </Link>

      {isQuestionsFeatureEnabled && (
        <Link url={`${fullUrl}otzyvy/#new-question`} target="blank" onClick={onQuestionLinkClick}>
          <QuestionOnboardingFeature
            isShown={isOnboardingShown}
            onClose={onOnboardingClose}
            onShow={handleOnboardingShown}
          >
            <Button size="XS" theme="fill_secondary">
              Задать вопрос
            </Button>
          </QuestionOnboardingFeature>
        </Link>
      )}

      {!isQuestionsFeatureEnabled && (
        <Link url={`${fullUrl}otzyvy/`} target="blank" data-testid="ShowReviewsLink" onClick={showReviewsLinkClick}>
          <Button size="XS" theme="stroke_primary">
            Показать {reviewsCountText}
          </Button>
        </Link>
      )}
    </div>
  );
};
